





































import { formatDate } from '@/utils';
import { getColors } from '@/utils/app-setting';
import Constants from '@/utils/constants';
import { truncateDate } from '@/utils/date-util';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import CalendarButton from '../atoms/CalendarButton.vue'
  
@Component({
    name: 'PopupDatePicker',
    components: {
        CalendarButton
    }
})
export default class PopupDatePicker extends Vue {
  @Prop({ default: () => false }) disabled! : boolean
  @Prop({ default: () => [] }) businessDays! : string[]
  @Prop({ default: () => '' }) formatDate! : string
  @Prop({ default: () => '' }) dateLabel!: string
  @Prop({ default: () => [] }) nonTargetDays! : { am: boolean; pm: boolean;}[]
  // カレンダーpopupメニュー
  public menu = false
  public date = ''
  public selectedFormatDate = ''
  public minDate = truncateDate(new Date())
  public maxDate = this.getMaxDate()
  public allowedDates : string[] = []
  public disabledDate : string[] = []
  public result: any;
  public colors = getColors()
  public formBgColor = this.colors.formBgColor

  created() {
    this.allowedDates = this.getAllowedDates()
    this.setDateStr()
  }

  public getMaxDate() {
    let date = truncateDate(new Date())
    date.setFullYear(date.getFullYear() + 1)
    return date
  }

  public getAllowedDates(): string[] {
    let dates = []
    for(let businessDay of this.businessDays) {
      if (new Date(businessDay) < this.minDate ||  this.maxDate < new Date(businessDay)) {
        continue
      }
      var day = this.nonTargetDays[new Date(businessDay).getDay()]
      if (day && !day.am && !day.pm) {
        continue
      }
      dates.push(businessDay)
    }
    return dates
  }

  public isAllowedDates(dateStr: string) {
    if (!this.allowedDates.includes(dateStr)) {
      return false
    }
    return true
  }

  public setDate() {
    this.menu = false
    this.$emit(
      'set-date',
      this.date
    )
  }
  
  @Watch('formatDate')
  public setDateStr() {
    this.selectedFormatDate = formatDate(this.formatDate, Constants.DateFormat.YYYYNEN_MMGATU_DDNICHI)
  }

  public onClick() {
    this.allowedDates = this.getAllowedDates()
    this.$emit(
      'on-click',
      true
    )
  }
}
